<template>
  <svg
    width="340"
    height="60"
    viewBox="0 0 340 60"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    class="c-app-footer-logo"
  >
    <path
      d="M99.398 12.939c0-7.087-6.56-13.298-14.04-13.298H65.55c-3.911 0-7.503 1.536-10.126 4.32-2.464 2.624-3.879 6.185-3.879 9.768v32.542c0 3.556 1.53 6.979 4.313 9.648 2.694 2.584 6.228 4.063 9.692 4.063l17.977.008 2.304-.008c3.388 0 6.799-1.439 9.351-3.943 2.721-2.669 4.216-6.274 4.216-10.15V12.934zm-10.422 31.36c0 3.326-2.698 6.034-6.011 6.034H68.018c-3.313 0-6.012-2.708-6.012-6.034V15.328c0-1.612.624-3.126 1.761-4.267a5.96 5.96 0 0 1 4.251-1.768h14.947c2.902 0 6.011 2.425 6.011 6.035z"
      fill="url(#footer-logo-gradient)"
    />
    <path
      d="M239.607 8.549v42.545c0 4.906 3.977 8.902 8.869 8.902h31.849v-9.653h-30.296V33.755h27.788v-9.129h-27.788V9.308h30.296V-.349h-31.849c-4.888 0-8.869 3.991-8.869 8.902z"
      fill="url(#footer-logo-gradient)"
    />
    <path
      d="m.011 9.236-.013 50.759h10.435v-28.39h27.952v-9.129H10.433v-9.453c0-2.051 1.663-3.721 3.707-3.721h26.837V-.359H10.084C4.713-.359.294 3.854.016 9.231z"
      fill="url(#footer-logo-gradient)"
    />
    <path
      d="m321.722 29.843.137-.231L340-.354l-11.369-.009-12.231 20.18-.38.626-.376-.626-12.235-20.18-11.364.009 18.136 29.966.142.231-.142.231-18.136 29.917 11.421.009 12.178-20.118.376-.626.38.626L328.578 60 340 59.991l-18.141-29.917z"
      fill="url(#footer-logo-gradient)"
    />
    <path
      d="m148.975 35.261.363-.178c4.733-2.34 7.789-6.98 7.789-11.824V12.945c0-7.087-6.56-13.298-14.04-13.298h-30.831v60.345h10.421V36.593h15.359l.106.284 8.745 23.111h11.47l-9.236-24.354-.142-.378zm-2.269-14.391c0 3.655-3.07 5.977-5.91 6.03h-18.123V9.304h18.021c2.902 0 6.007 2.429 6.007 6.034v5.532z"
      fill="url(#footer-logo-gradient)"
    />
    <path
      d="M215.224 50.134c0 .266-.363.35-.478.106L193.213 4.756c-1.451-3.108-4.596-5.115-8.011-5.115h-6.321c-3.632 0-7.516 3.028-7.516 7.53v52.815h10.426V9.276c0-.267.363-.351.478-.107l21.556 45.707c1.45 3.103 4.595 5.11 8.01 5.11h4.189c7.127 0 9.652-2.322 9.652-8.876V-.355h-10.421z"
      fill="url(#footer-logo-gradient)"
    />

    <defs>
      <linearGradient
        id="footer-logo-gradient"
        x1="1"
        y1="0"
        x2="1"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#16181F" />
        <stop offset="1" stop-color="#16181F" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="postcss">
html:not(.dark) .c-app-footer-logo path {
  fill: currentColor;
}
</style>
